import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import brandConfig from 'brandConfig'
import { SIGNUP_PROFILE_DISPATCH } from '../../../store/reducers/auth/signup'
import { TermsNotAccepted } from '../../popups/signUp'
import OptionalCheckbox from '../optionalCheckbox/OptionalCheckbox'
import PrivacyPolicyCheckbox from '../privacyPolicyCheckbox/PrivacyPolicyCheckbox'
import TermsCheckbox from '../termsCheckbox/TermsCheckbox'

const OptionalAndMandatoryCheckboxes = ({
  signupProfile,
  onCancelTerms,
  onAcceptTermsSubmit,
  dispatchActionSignup,
  onClickPrivacyPolicy,
  privacyPolicyClickError,
  children
}) => {
  const { t } = useTranslation()
  const {
    newsletterCheckbox,
    disablePrivacyCheckbox,
    disableTermsCheckbox,
    enableMandatoryCheckbox
  } = brandConfig.features
  const { error, optionalCheckbox, mandatoryCheckbox } = signupProfile
  return (
    <TermsNotAccepted
      signupProfile={signupProfile}
      dispatchAction={dispatchActionSignup}
      onAcceptTermsSubmit={onAcceptTermsSubmit}
      onCancelTerms={onCancelTerms}
      t={t}
    >
      {!disableTermsCheckbox && (
        <TermsCheckbox
          dispatchAction={dispatchActionSignup}
          signupProfile={signupProfile}
          t={t}
        />
      )}
      {!disablePrivacyCheckbox && (
        <PrivacyPolicyCheckbox
          dispatchAction={dispatchActionSignup}
          signupProfile={signupProfile}
          onClickPrivacyPolicy={onClickPrivacyPolicy}
          privacyPolicyClickError={privacyPolicyClickError}
          t={t}
        />
      )}
      {enableMandatoryCheckbox && (
        <OptionalCheckbox
          dispatchAction={dispatchActionSignup}
          error={error}
          checkbox={mandatoryCheckbox}
          description={t('brand:common.mandatory-checkbox')}
          dispatchCheckbox={SIGNUP_PROFILE_DISPATCH.MANDATORY_CHECKBOX}
        />
      )}
      {children}
      {newsletterCheckbox && (
        <OptionalCheckbox
          dispatchAction={dispatchActionSignup}
          error={error}
          checkbox={optionalCheckbox}
          description={t('brand:common.opt-for-newsletter')}
          dispatchCheckbox={SIGNUP_PROFILE_DISPATCH.OPTIONAL_CHECKBOX}
        />
      )}
    </TermsNotAccepted>
  )
}

export default memo(OptionalAndMandatoryCheckboxes)
